import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { FreightsCompanyRequest } from './freights-company-request';

export class FreightsCompanyResponseModel extends GlobalResponseObject{
    data?: FreightsCompanyRequest[];
    /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data //FreightsCompany[]
     */
     constructor(status: boolean, intlCode: number, internalMessage: string, data?: FreightsCompanyRequest[]) {
        super(status, intlCode, internalMessage);
        this.data = data;
    }
}
